<div class="tooltip-wrapper relative inline-block rounded">
  <img ngSrc="assets/images/icons/info.svg" alt="Info icon" width="16" height="16" class="cursor-pointer">

  <div [ngClass]="{'visible opacity-1': showTooltip, 'invisible  opacity-0': !showTooltip}"
       id="tooltip-no-arrow"
       role="tooltip"
       class="absolute z-10 inline-block px-3 py-2 text-sm font-medium text-white transition-opacity
        duration-300 bg-gray-900 rounded-lg shadow-xs tooltip dark:bg-gray-700 bg-[#525359]"
       [style.min-width]="{minWidth} + 'px'">
    <ng-content></ng-content>
  </div>
</div>

